<script setup lang="ts">
import { inject } from "vue";

import type { BadgeProps } from "@/components/ui/ColorBadge.vue";
import { slugify } from "@/services/utils";

const props = defineProps<{
  name: string;
  icon?: string;
  disabled?: boolean;
  badge?: BadgeProps;
}>();
const selectedTabSlug = inject("selectedTabSlug");
</script>

<template>
  <div class="tab-content" v-if="slugify(props.name) === selectedTabSlug">
    <slot />
  </div>
</template>

<style scoped>
.tab-content {
  width: 100%;
}
</style>
